export default __webpack_public_path__ + "static/media/contacts.a12b3cff.svg";